import x2js from 'x2js';

export default angular
  .module('app')
  .value('X2JS', x2js)
  .name;



// WEBPACK FOOTER //
// ./src/holding/modules/app/values/xml.js